<!--
	作者：masonchen
	时间：2017-04-10
	描述：轨迹回放页面
-->
<template>
	<!--车辆监控页面_右侧tab面板之设备命令开始-->
	<div class="tab-bar">
		<div class="tab-row">
			<div class="track_top_btn03"><span>请选择指令：</span>
				<select v-model="instruction" @change="getCmdName(instruction)">
					<option :value="cmd.cmdId" v-for="(cmd,index) in cmdList">{{cmd.cmdName}}</option>
				</select>
			</div>
			<div class="track_top_btn04"><span>请选择设备：</span></div>
			<div class="device_info">
			  <ul>
			    <li v-for="(device,index) in deviceList" @mouseover="showTips" @mouseout="hideTips">
				  <p>
				  	<span>VD{{device.id}}</span>
				  	<em><input type="checkbox" v-model="device.isChecked" @change="check(device.isChecked,device.id)" :disabled="device.categoryId!=curInst.categoryId"/></em>
				  </p>
				  <b>类型：{{device.wifiFlag===1?'有线':'无线'}}{{device.mainFlag===1?'| 主设备 ':''}}</b>
				  <b>设备号：{{device.deviceNum}}</b>
				</li>
			  </ul>	
			</div>			
		</div>
		<div class="track_bottom_btn04">
			  <i @click="selectAll"><a class="ico_01">全选</a></i>
			  <i @click="unselect"><a class="ico_02">反选</a></i>
			  <i @click="dispatchInstro"><a class="ico_03">下发指令</a></i>
		</div>
	</div>
	<!--车辆监控页面_右侧tab面板之设备命令结束-->
</template>
<script>
	import {
		mapState
	} from 'vuex'
	export default {
		name: 'DeviceInstructions',
		data() {
			return {
				instruction:'', //指令id
				curInst:{},		//当前选中的命令
				notMatch:true,
				tipShow:false
			}
		},
		computed: mapState({
			curInstVInfo:state=>state.monitor.curInstVInfo,  //派发指令的车辆信息
			cmdList:state=>state.monitor.cmdList,
			deviceList:state=>state.monitor.deviceList,
			checkedDevice:state=>state.monitor.checkedDevice //被选中的设备集合
		}),
		methods: {
			showTips(){
				this.tipShow = true;
			},
			hideTips(){
				this.tipShow = false;
			},
			selectAll(){//全选
				if(this.instruction!=''){
					this.$store.dispatch('insAllDevice',this.curInst)
				}
			},
			unselect(){//反选
				if(this.instruction!=''){
					this.$store.dispatch('insOppDevice',this.curInst)
				}
			},
			check(bool,dId){
				if(bool){
					this.$store.dispatch('insCheckedDevice',dId)//选中
				}else{
					this.$store.dispatch('insRemovedDevice',dId)//取消选中
				}
			},  
			dispatchInstro(){
				let instName = 'InsGoloxLoading'
				if(this.instruction == ''){
					this.$store.dispatch('tipModalShow','请先选择要发送的指令')
				}
				if(this.checkedDevice.length === 0){
					this.$store.dispatch('tipModalShow','请先选择定位设备')
					return;
				}
				if(this.instruction != ''){
					const obj = {//'InsBKAlarmClock'//
						name:this.curInst.cmdName,		//指令名称
						id:this.curInst.winId,                 //指令对应组件名
						cmdType:this.curInst.cmdType,   //命令类型0:网路指令；1:短信指令
						vId:this.curInstVInfo.vehicleId,
						cmd:this.curInst.clientCmd
					}
					this.$store.dispatch('instModalShow',obj)	
				}
			},
			getCmdName(id){
				for(let i = 0,l = this.deviceList.length; i < l; i ++){
					this.deviceList[i].isChecked = false
				}
				this.$store.dispatch('insRemoveAll')
				let index = this.cmdList.findIndex(n=>n.cmdId == id)
				this.curInst = this.cmdList[index]
			}
		}
	}
</script> 


// WEBPACK FOOTER //
// DeviceInstructions.vue?6427a4d9